import { z } from "zod";

export const DTODocumentationPublishTypeQueryParams = z.object({
  environment: z.enum(["Live", "Preview"]),
});

export type DTODocumentationPublishTypeQueryParams = z.infer<typeof DTODocumentationPublishTypeQueryParams>;
